/* eslint-env browser */
import plyr from '../../_modules/plyr/scripts';
import Domodule from 'domodule';
import { addClass, removeClass, styles, on } from 'domassist';

class HeroVideo extends Domodule {
  postInit() {
    this.player = plyr.setup();

    this.player.on('ready', () => {
      setTimeout(() => {
        this.play();
      }, 1000);
    });

    on(this.el, 'plyr:playing', () => {
      removeClass(this.el, 'video-transition');
    });

    on(this.el, 'plyr:ended', this.close.bind(this));
  }

  close() {
    removeClass(this.el, 'video-playing');

    styles(this.els.play, {
      zIndex: 1
    });

    setTimeout(() => {
      styles([this.els.close, this.els.videoContainer], {
        zIndex: -1
      });
    }, 410);

    this.player.stop();
  }

  play() {
    addClass(this.el, 'video-playing');

    try {
      this.player.setVolume(5);
      addClass(this.el, 'video-transition');
    } catch (e) {
      // Error silently
    }

    this.player.play();

    styles(this.els.videoContainer, {
      zIndex: 1
    });

    styles(this.els.close, {
      zIndex: 20
    });

    styles(this.els.play, {
      zIndex: -1
    });
  }
}

Domodule.register('HeroVideo', HeroVideo);
